var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2905 7.10976C14.6363 6.7621 14.8981 6.32616 14.9821 5.84299C15.1153 5.07333 14.8735 4.33851 14.349 3.81043L13.4611 2.91842C12.5747 2.02719 11.1245 2.02719 10.2381 2.91842L9.75676 3.40314C9.66126 3.49916 9.66126 3.65479 9.75676 3.75081L13.5212 7.53563C13.6166 7.63165 13.7714 7.63165 13.8669 7.53563L14.2905 7.10976ZM12.75 8.66574L7.0225 14.4173C6.62665 14.8145 6.0891 15.0383 5.52844 15.0383H2.79602C2.65047 15.0383 2.51261 14.9795 2.40326 14.8773C2.3016 14.7681 2.25 14.6287 2.25 14.4754L2.32316 11.7103C2.33009 11.1621 2.55574 10.6426 2.94158 10.2546L8.639 4.5255C8.7345 4.42949 8.89006 4.42949 8.98556 4.5255L12.75 8.31808C12.8455 8.41409 12.8455 8.56973 12.75 8.66574ZM15.1724 15.0395H10.1966C9.87773 15.0395 9.61896 14.7793 9.61896 14.4587C9.61896 14.1382 9.87773 13.878 10.1966 13.878H15.1724C15.4912 13.878 15.75 14.1382 15.75 14.4587C15.75 14.7793 15.4912 15.0395 15.1724 15.0395Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9,
    y1: 2.25,
    x2: 9,
    y2: 15.0395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12BBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5348DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.907757c4bee68da07f7394ddf6a67d9c.svg";
export { ForwardRef as ReactComponent };